import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { DcrPage } from '../../../dcr/dcr-page.tsx';
import {
  EcosystemSearch,
  ecosystemSearchOf,
  requestedEcosystemOf,
} from '../../search/ecosystem-search.ts';
import { InvalidLinkPage } from '../../search/invalid-link-page.tsx';

// Declared inline: the route plugin splits `component` and `errorComponent` into lazy bindings it
// declares after the options. The URL tests mount `Route.options` in a memory router.
export const Route = createFileRoute('/dcr/')({
  validateSearch: Schema.toStandardSchemaV1(EcosystemSearch),
  component: DcrRoute,
  errorComponent: InvalidLinkPage,
});

// Another ecosystem is another view: it gets its own history entry.
function DcrRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  return (
    <DcrPage
      ecosystem={requestedEcosystemOf(Route.useSearch())}
      onEcosystem={(next) => {
        void navigate({ search: ecosystemSearchOf(next) });
      }}
    />
  );
}
